import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input,message } from 'antd';
import auth1 from '../../../assets/images/auth/08.jpg';
import axios from 'axios';
import { SERVER_ADDRESS } from '../../../Config/Config';
import { useNavigate } from 'react-router-dom';

const SignIn = () => {
   const [form] = Form.useForm();
   const [loading,setLoading] = useState(false);
   const navigate = useNavigate();
   const handleLogin = async(values) =>{
      setLoading(true)
      try {
         const response = await axios.post(`${SERVER_ADDRESS}/api/login`,values);
         if(response.status===200){
            localStorage.setItem('token',response.data.data);
            const userData= JSON.parse(atob(response.data.data.split('.')[1]));
            console.log(userData)
            localStorage.setItem('username',userData.name);
            localStorage.setItem('userRole',userData.role)
            navigate('/dashboard')
            message.success({content:'Logged In successfully',duration:2});
            setLoading(false)
         }
         else if(response.status===404){
            message.error({content:`${response.message}`,duration:2})
            setLoading(false)
         }
         else if(response.status===400){
            message.error({content:`${response.message}`,duration:2})
            setLoading(false)
         }
         else{
               message.error({content:`${response.message}`,duration:2})
               setLoading(false)
            }
            
      } catch (error) {
         if(error.response.status === 400){
            message.error({content:`${error.response.data.message}`,duration:2})
            setLoading(false)
         }
         else if(error.response.status===404){
            message.error({content:`${error.response.data.message}`,duration:2})
            setLoading(false)
         }
         else{
            message.error({content:'Internal Server Error',duration:2})
            setLoading(false)
         }
      }
   }

   return (
      <>
         <section className="login-content">
            <div className="background-overlay"></div>

            <Row className="m-0 align-items-center justify-content-center vh-100">
               <Col xs={12} md={6} lg={4} className="glass-form p-5 rounded">
                  <div className="text-center mb-4">
                     <h2 style={{ color: 'white' }}>Matrimony Login</h2>
                  </div>
                  <Form
                     form={ form }
                     name="login"
                     initialValues={{ remember: true }}
                     layout="vertical"
                     style={{ width: '100%' }}
                     onFinish={handleLogin}
                  >
                     <Form.Item
                        label={<span className="text-white">Email</span>}
                        name="email"
                        rules={[{ required: true, message: 'Please input your Email!' },{type:'email',message:"Enter valid email"}]}
                     >
                        <Input prefix={<UserOutlined />} placeholder="Enter the email" />
                     </Form.Item>

                     <Form.Item
                        label={<span className="text-white">Password</span>}
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                     >
                        <Input.Password prefix={<LockOutlined />} placeholder="Enter the password" />
                     </Form.Item>

                     <Form.Item>
                        <Button loading={loading} block type="primary" htmlType="submit">
                           Log in
                        </Button>
                     </Form.Item>
                  </Form>
               </Col>
            </Row>
         </section>

         {/* CSS Styles */}
         <style>{`
            .background-overlay {
               background: url(${auth1}) no-repeat center center fixed;
               background-size: cover;
               position: absolute;
               width: 100%;
               height: 100%;
               filter: blur(10px);
               top: 0;
               left: 0;
               z-index: -1;
            }

            .glass-form {
               background: rgba(255, 255, 255, 0.1);
               border-radius: 16px;
               box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
               backdrop-filter: blur(10px);
               -webkit-backdrop-filter: blur(10px);
               border: 1px solid rgba(255, 255, 255, 0.3);
            }

            .glass-form input {
               background: rgba(255, 255, 255, 0.2);
               border: none;
               color: #fff;
            }

            .glass-form input::placeholder {
               color: rgba(0, 0, 0, 0.6);
            }

            .glass-form .ant-form-item-label > label {
               color: #fff;
            }
         `}</style>
      </>
   );
};

export default SignIn;
